import {useNavigate, useParams} from "react-router";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { findEditId } from "../service/proposal.service";
import { Alert, Backdrop, CircularProgress } from "@mui/material";
import { ProposalFormToEdit } from "../components/proposal/ProposalFormToEdit";

export function PublicEditPage() {
    const {id: idToEdit} = useParams();
    const navigate = useNavigate();

    const {data, isFetching, error} = useQuery({
        queryKey: ['proposals-by-edit-id', idToEdit],
        refetchOnWindowFocus: false,
        queryFn: () => {
            return findEditId(idToEdit!).then(response => response.data)
        },
        placeholderData: keepPreviousData
    });

    return isFetching
        ? <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={true}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
        : (
        error
            ? <Alert color={"error"}>{error.message}</Alert>
            : <ProposalFormToEdit goBack={() => navigate("/")} id={data!.id} defaultData={data} publicEdit />
        )
}